<template>
    <div>
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.provider_competition.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.provider_competition.error') }}
        </div>

        <template v-else-if="providerCompetition">
            <intelligence-provider-competition-kpi-cards
                :kpis="providerCompetition.kpis"
            ></intelligence-provider-competition-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-provider-competition-chart
                    :providers="providerCompetition.providers"
                ></intelligence-provider-competition-chart>
                <intelligence-provider-competition-table
                    :providers="providerCompetition.providers"
                ></intelligence-provider-competition-table>
            </div>
        </template>
    </div>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceProviderCompetitionKpiCards from 'components/page-elements/intelligence/IntelligenceProviderCompetitionKpiCards'
    import IntelligenceProviderCompetitionChart from 'components/page-elements/intelligence/IntelligenceProviderCompetitionChart'
    import IntelligenceProviderCompetitionTable from 'components/page-elements/intelligence/IntelligenceProviderCompetitionTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceProviderCompetitionKpiCards,
            IntelligenceProviderCompetitionChart,
            IntelligenceProviderCompetitionTable,
        },

        props: {
            filters: { type: Object, default: null },
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                providerCompetition: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.provider_competition.title')
            },
        },

        methods: {
            loadProviderCompetition() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getProviderCompetition(this.filters)
                    .then((response) => {
                        this.providerCompetition = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.providerCompetition = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        watch: {
            filters: {
                immediate: true,
                handler() {
                    this.loadProviderCompetition()
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
